import React, { useCallback, useState } from 'react';
import t from 'rcm-i18n';
import './PwsCouponOwnerControlsComponent.scss'
import { CouponFromConfigConfig } from './types';
import { PWS_COUPONS_VALIDATION_RULES } from '@reliv/pws-core/src';
import { CouponRowCustomizeModal } from './CouponRowCustomizeModal';
import { CouponRowGetLinkModal } from './CouponRowGetLinkModal';
import { Button } from 'forms';
import './CouponRow.scss';
interface Props {
    coupon: CouponFromConfigConfig;
    onCouponToggle: (couponId: string) => void;
    enabledCouponCodeIds: string[];
    onCouponCodeValueChange: (couponId: string, newCouponCodeValue: string) => void;
}

export default function CouponRow({ coupon, onCouponToggle, enabledCouponCodeIds, onCouponCodeValueChange }: Props) {
    const [editCodeDialogOpen, setEditCodeDialogOpen] = useState(false);
    const [getLinkDialogOpen, setGetLinkDialogOpen] = useState(false);
    const [newCouponCodeValue, setNewCouponCodeValue] = useState('');

    const handleCheckChanged = useCallback(() => {
        onCouponToggle(coupon.id)
    }, [onCouponToggle]);

    const handleCustomizeDialogCancel = useCallback(() => {
        setEditCodeDialogOpen(false);
    }, []);

    const handleCustomizeDialogOk = useCallback(() => {
        onCouponCodeValueChange(coupon.id, newCouponCodeValue);
        setEditCodeDialogOpen(false);
    }, [coupon.id, newCouponCodeValue, onCouponCodeValueChange]);

    const handleOpenDialogClick = useCallback(() => {
        setEditCodeDialogOpen(true);
        setNewCouponCodeValue(coupon.couponCode);
    }, [coupon.couponCode]);

    const handleOpenGetLinkDialogClick = useCallback(() => {
        setGetLinkDialogOpen(true);
    }, []);

    const handleOpenGetLinkDialogClose = useCallback(() => {
        setGetLinkDialogOpen(false)
    }, []);

    const handleNewCouponCodeValueInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        if (!value.startsWith(PWS_COUPONS_VALIDATION_RULES.customCouponCodeValue.mustStartWith)) {
            value = PWS_COUPONS_VALIDATION_RULES.customCouponCodeValue.mustStartWith;
        }
        if (value.length > PWS_COUPONS_VALIDATION_RULES.customCouponCodeValue.maxLength) {
            value = value.substring(0, PWS_COUPONS_VALIDATION_RULES.customCouponCodeValue.maxLength)
        }
        setNewCouponCodeValue(value.toLocaleUpperCase());
    }, []);

    const couponEnabled = enabledCouponCodeIds?.includes(coupon.id);

    return <div className={couponEnabled ? "panel panel-primary CouponRow" : "panel panel-default CouponRow"}>
        <div className="panel-heading CouponRow-heading-title">
            <strong>{t('Give Retail Customers {discountPercent}% Off', coupon)}</strong>
        </div>
        <div className="panel-body">
            <div className="row">
                <div className="col-lg-4">
                    <span className="CouponRow-coupon-code-label">{t('Coupon Code')}:</span>
                    &nbsp;
                    <span className={couponEnabled ? '' : 'PwsCouponOwnerControlsComponent-couponDisabled'}>
                        <strong>{coupon.couponCode}</strong>
                    </span>
                    &nbsp;
                    <span className="CouponRow-disabled-hint">{couponEnabled ? '' : '(' + t('Disabled') + ')'}</span>
                </div>
                <div className="col-lg-8 CouponRow-align-right CouponRow-main-buttons-wrap">
                    <Button text={t('Get Link')}
                        icon="link"
                        className="btn btn-default"
                        type="button"
                        onClick={handleOpenGetLinkDialogClick} />
                    <Button text={t('Customize coupon code')}
                        icon="edit"
                        className="btn btn-default"
                        type="button"
                        onClick={handleOpenDialogClick} />
                    <span className="pull-right">&nbsp;</span>
                    {couponEnabled ?
                        <Button text={t('Disable this coupon')}
                            icon="remove"
                            className="btn btn-default"
                            type="button"
                            onClick={handleCheckChanged} /> :
                        <Button text={t('Enable this coupon')}
                            icon="ok"
                            className="btn btn-primary"
                            type="button"
                            onClick={handleCheckChanged} />
                    }
                    <div className="clearfix" />
                </div>
            </div>
            <div>
            </div>
            <CouponRowCustomizeModal
                open={editCodeDialogOpen}
                onOk={handleCustomizeDialogOk}
                onCancel={handleCustomizeDialogCancel}
                coupon={coupon}
                value={newCouponCodeValue}
                onValueChange={handleNewCouponCodeValueInputChange}
            />
            <CouponRowGetLinkModal
                open={getLinkDialogOpen}
                onOk={handleOpenGetLinkDialogClose}
                coupon={coupon} />
        </div>
    </div>
}